export class Ball {
  x = 0.5;
  y = 0.5;
  r = 1/40;

  dx = 0.005;
  dy = -0.005;

  rebound(nor: number[], pt: number[]) {
    const asy = [nor[1],-nor[0]];
    const vec = [this.dx, this.dy];
    const base = [vec[0]*nor[0]+vec[1]*nor[1], vec[0]*asy[0]+vec[1]*asy[1]];
    base[0] *= -1;
    this.dx = base[0]*nor[0]+base[1]*asy[0];
    this.dy = base[0]*nor[1]+base[1]*asy[1];
    this.x = pt[0];
    this.y = pt[1];
    if(Number.isNaN(this.dx)) {
      console.log(nor, asy, base);
    }
  }

  move(maxY: number) {
    let nx = this.x + this.dx;
    let ny = this.y + this.dy;
    if(nx > 1 - this.r) {
      this.rebound([-1, 0],[1 - this.r, this.y]);
    }
    if(nx < this.r) {
      this.rebound([1, 0],[this.r, this.y]);
    }
    if(ny > maxY - this.r) {
      this.rebound([0, -1],[this.x, maxY - this.r]);
    }
    if(ny < this.r) {
      this.rebound([0, 1],[this.x, this.r]);
    }
    this.x = nx;
    this.y = ny;
  }
}
